import React, {Component} from "react";
import LinksContainer from "../../components/linkelement/LinksContainer";
import LinkCardMain from "../../components/linkelement/LinkCardMain";
import LinkCard from "../../components/linkelement/LinkCard";

class GemLinksAusschuss extends Component {

  render() {
    return <LinksContainer mainTagTitle='Auswahl' title='Freikirche der Siebenten-Tags-Adventisten Gemeinde Langau i.E.' width='140px' subtitle='Zugang zur DSV-Cloud — Wähle eine Kachel.'>
      <LinkCard link='gemausschussWgodPgktnAlf9S3kgjQ1lgjdsGfk6' numOfColumns='1' title='1' subtitle='Ich bin im Ausschuss' description='' />
      <LinkCard link='gemgliederWgodPgkZnAlf0S3kgjQ1lgjdsGfk6' numOfColumns='1' title='2' subtitle='Ich bin ein Gemeindeglied' description='' />
      <LinkCard link='gemgaesteSgodPgktnAlf9S3kgjQ3lgjdsGfk6' numOfColumns='1' title='3' subtitle='Ich bin Gast' description='' />
    </LinksContainer>
  }
}

export default GemLinksAusschuss;
